
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as ModelPrincipal } from '../../controlador';
    import { Controlador as Model } from './controlador';
    import buscador from './lista-buscador.vue';
    import opciones_listado from './lista-buscador-opciones-listado.vue';
    import titulo from './lista-buscador-tipo.vue';
    import listado from './lista-listado.vue';
    import paginacion from './lista-listado-paginacion.vue';
    import filtros_activos from './lista-buscador-filtros-activos.vue';
    import resumen from '../resumen/resumen.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            buscador,
            listado,
            filtros_activos,
            titulo,
            paginacion,
            resumen,
            opciones_listado
        }
    } )
    export default class Componente extends Vue
    {
        public get Principal() { return Vue.observable( ModelPrincipal ); }
        public get Controlador() { return Vue.observable( Model ); }
        public get Buscador() { return this.Controlador.Buscador; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            //this.Controlador.Buscador.Filtros.set( this.$route.query );
            this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'preparando-retira-cliente' )
            this.Controlador.Buscador.Buscar(1);

        }
    }
